import { render, staticRenderFns } from "./leadsPerStudio.vue?vue&type=template&id=b2331b42"
import script from "./leadsPerStudio.vue?vue&type=script&lang=js"
export * from "./leadsPerStudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports